/* Product pages: a "Turn it in 3D" button on the main photo, and a short show on the gallery's own 3D model
   (one full turn, then a hand that shows how to drag it). Uses the theme's existing viewer, so there is only one model in memory. */
(function () {
  var gallery = document.querySelector('product-gallery');
  if (!gallery) return;
  var slide = gallery.querySelector('.product-gallery__media[data-media-type="model"]');
  var media = slide && slide.querySelector('model-media');
  if (!media) return;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var touch = matchMedia('(pointer: coarse)').matches;
  var dragged = false;
  try { dragged = localStorage.getItem('mj-vr-dragged') === '1'; } catch (e) {}

  var css = ''
    + '.mj3d-pill{position:absolute;left:12px;bottom:12px;right:auto;width:auto;max-width:calc(100% - 24px);min-width:0;margin:0;z-index:3;display:inline-flex;align-items:center;gap:8px;padding:9px 14px;border-radius:999px;border:0;background:rgba(0,59,54,.92);color:#FFF9EA;font:500 13px/1 var(--text-font-family,sans-serif);cursor:pointer;box-shadow:0 2px 10px rgba(0,40,36,.18)}'
    + '.mj3d-pill svg{width:16px;height:16px}'
    + '.mj3d-layer{position:absolute;inset:0;z-index:4;pointer-events:none;overflow:hidden}'
    + '.mj3d-hand{position:absolute;left:0;top:0;width:72px;height:72px;opacity:0;filter:drop-shadow(0 4px 8px rgba(0,40,36,.28))}'
    + '.mj3d-hand svg{width:72px;height:72px;display:block;transition:transform .15s}'
    + '.mj3d-hand.is-pressed svg{transform:scale(.9) translateY(2px)}'
    + '.mj3d-ring{position:absolute;left:16px;top:-14px;width:40px;height:40px;border-radius:50%;border:2px solid #C39A43;opacity:0;transform:scale(.4);transition:opacity .2s,transform .35s}'
    + '.mj3d-hand.is-pressed .mj3d-ring{opacity:1;transform:scale(1.15)}'
    + '.mj3d-cap{position:absolute;left:50%;bottom:18px;transform:translate(-50%,8px);background:rgba(0,59,54,.92);color:#FFF9EA;font:13.5px/1.2 var(--text-font-family,sans-serif);padding:8px 16px;border-radius:999px;opacity:0;transition:opacity .35s,transform .35s;white-space:nowrap}'
    + '.mj3d-cap.is-on{opacity:1;transform:translate(-50%,0)}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  // 1. "Turn it in 3D" on the first photo
  var first = gallery.querySelector('.product-gallery__media');
  if (first && first !== slide) {
    if (getComputedStyle(first).position === 'static') first.style.position = 'relative';
    var pill = document.createElement('button');
    pill.type = 'button'; pill.className = 'mj3d-pill';
    pill.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M3 12a9 4 0 0 0 18 0M17 9.5l4 2.5-3.5 3"/></svg><span>Turn it in 3D</span>';
    pill.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var thumb = gallery.querySelector('.product-gallery__thumbnail[data-media-type="model"]');
      if (thumb && thumb.offsetParent) thumb.click();
      else slide.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
      settleThenPlay();
    });
    first.appendChild(pill);
  }

  // start the model only once the gallery has stopped scrolling, otherwise the gallery pauses it again
  var ourPlayAt = 0;
  function settleThenPlay() {
    var last = null, stable = 0, n = 0;
    (function check() {
      var x = Math.round(slide.getBoundingClientRect().left);
      stable = x === last ? stable + 1 : 0; last = x;
      if (stable >= 3 || n++ > 30) { ourPlayAt = Date.now(); try { media.play(); } catch (e) {} }
      else setTimeout(check, 100);
    })();
  }

  // 2. the show, once per page, until the visitor has dragged a model somewhere on the site
  if (reduce) return;
  if (getComputedStyle(slide).position === 'static') slide.style.position = 'relative';
  var layer = document.createElement('div'); layer.className = 'mj3d-layer'; layer.setAttribute('aria-hidden', 'true');
  layer.innerHTML = '<div class="mj3d-hand"><span class="mj3d-ring"></span><svg viewBox="0 0 48 48"><path d="M24 4a4 4 0 0 1 4 4v13.2l7.6 1.3a4.5 4.5 0 0 1 3.7 5.1l-1.6 9.6A7 7 0 0 1 30.8 43H23a7 7 0 0 1-5.4-2.6l-6.9-8.6a3.2 3.2 0 0 1 4.6-4.4L20 31V8a4 4 0 0 1 4-4z" fill="#FFFDF7" stroke="#003B36" stroke-width="2" stroke-linejoin="round"/><path d="M28 21v8M33 22v7" stroke="#003B36" stroke-width="1.6" stroke-linecap="round"/></svg></div><p class="mj3d-cap"></p>';
  slide.appendChild(layer);
  var hand = layer.querySelector('.mj3d-hand'), cap = layer.querySelector('.mj3d-cap');
  var token = 0, shown = false, STOP = {};

  function stop(why) { if (typeof why === 'string') slide.dataset.mj3dStop = why; else if (why && why.type) slide.dataset.mj3dStop = why.type; token++; hand.style.opacity = 0; cap.classList.remove('is-on'); }
  function caption(t) { if (t) { cap.textContent = t; cap.classList.add('is-on'); } else cap.classList.remove('is-on'); }
  function place(xp, yp, pressed, a) {
    var r = slide.getBoundingClientRect();
    hand.style.transform = 'translate(' + (r.width * xp - 36) + 'px,' + (r.height * yp - 6) + 'px)';
    hand.style.opacity = a; hand.classList.toggle('is-pressed', !!pressed);
  }
  function tween(ms, fn, tk) {
    return new Promise(function (res, rej) {
      var s = performance.now();
      (function f(now) {
        if (tk !== token) return rej(STOP);
        var k = Math.min(1, (now - s) / ms); fn(k);
        if (k < 1) requestAnimationFrame(f); else res();
      })(s);
    });
  }
  var sine = function (k) { return -(Math.cos(Math.PI * k) - 1) / 2; };
  var lerp = function (a, b, k) { return a + (b - a) * k; };

  function ready(mv) {
    var r = slide.getBoundingClientRect(), o = mv.getCameraOrbit();
    return mv.loaded && r.width > 50 && r.right > 0 && r.left < innerWidth && o && isFinite(o.theta) && o.radius > 0;
  }
  function run(mv) {
    if (shown) return;
    var tries = 0;
    (function wait() {
      if (ready(mv)) start(mv);
      else if (tries++ < 40) setTimeout(wait, 250);
    })();
  }
  function start(mv) {
    if (shown) return;
    shown = true;
    var tk = ++token;
    slide.dataset.mj3dStop = '';
    var o = mv.getCameraOrbit(), th0 = o.theta * 180 / Math.PI, ph = 75;
    mv.autoRotate = false;
    var orbit = function (th) { mv.cameraOrbit = th + 'deg ' + ph + 'deg auto'; };
    caption('Every side, in 3D');
    tween(3800, function (k) { orbit(th0 + 360 * sine(k)); }, tk)
      .then(function () { caption(''); if (dragged) throw STOP; caption(touch ? 'Drag sideways to turn it' : 'Grab it and turn it yourself'); return tween(450, function (k) { place(0.38, lerp(0.72, 0.6, sine(k)), false, k); }, tk); })
      .then(function () { return tween(260, function (k) { place(0.38, 0.6, k > 0.3, 1); }, tk); })
      .then(function () { var t = th0 + 360; return tween(1500, function (k) { var e = sine(k); orbit(t - 110 * e); place(lerp(0.38, 0.64, e), 0.6, true, 1); }, tk); })
      .then(function () { return tween(260, function (k) { place(0.64, 0.6, k < 0.4, 1); }, tk); })
      .then(function () { return tween(450, function (k) { place(lerp(0.64, 0.7, k), lerp(0.6, 0.7, k), false, 1 - k); }, tk); })
      .then(function () { caption('Your turn'); return tween(1500, function () {}, tk); })
      .then(function () { caption(''); slide.dataset.mj3dStop = 'done'; }, function (e) { if (e !== STOP) slide.dataset.mj3dStop = 'error: ' + (e && e.message); hand.style.opacity = 0; caption(''); });
  }

  function hook(mv) {
    if (!mv || mv.dataset.mj3d) return;
    mv.dataset.mj3d = '1';
    mv.addEventListener('camera-change', function (e) {
      if (e.detail && e.detail.source === 'user-interaction') {
        stop('drag');
        if (!dragged) { dragged = true; try { localStorage.setItem('mj-vr-dragged', '1'); } catch (x) {} }
      }
    });
    if (mv.loaded) run(mv); else mv.addEventListener('load', function () { setTimeout(function () { run(mv); }, 300); }, { once: true });
  }
  slide.addEventListener('pointerdown', function () { stop('touch'); }, true);
  slide.addEventListener('media:play', function () {
    var tries = 0;
    (function look() {
      var mv = media.querySelector('model-viewer');
      if (mv && typeof mv.getCameraOrbit === 'function') hook(mv);
      else if (tries++ < 40) setTimeout(look, 250);
    })();
  });
  slide.addEventListener('media:pause', function () {
    if (Date.now() - ourPlayAt < 2500) { setTimeout(function () { try { media.play(); } catch (e) {} }, 150); return; }
    stop('pause');
  });
})();
